import * as React from "react";

import { cn } from "../lib/utils";

export interface InputProps extends React.ComponentProps<"input"> {
  "aria-invalid"?: boolean | "true" | "false" | "grammar" | "spelling";
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, "aria-invalid": ariaInvalid, ...props }, ref) => {
    return (
      <input
        type={type}
        aria-invalid={ariaInvalid}
        className={cn(
          "flex h-11 w-full rounded-md border-solid border-[0.5px] border-input bg-background px-3 py-2 text-sm text-left shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-input disabled:cursor-not-allowed disabled:opacity-50",
          ariaInvalid === true || ariaInvalid === "true"
            ? "border-error focus-visible:ring-error"
            : "",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
